<template>
  <div class="text-left">
    <button class="btn" @click="change('s')">
      <img src="../../assets/images/buttons/en_font_s_on.png" v-if="size === 's'" />
      <img src="../../assets/images/buttons/en_font_s_off.png" v-else />
    </button>
    <button class="btn" @click="change('m')">
      <img src="../../assets/images/buttons/en_font_m_on.png" v-if="size === 'm'" />
      <img src="../../assets/images/buttons/en_font_m_off.png" v-else />
    </button>
    <button class="btn" @click="change('l')">
      <img src="../../assets/images/buttons/en_font_l_on.png" v-if="size === 'l'" />
      <img src="../../assets/images/buttons/en_font_l_off.png" v-else />
    </button>
  </div>
</template>

<script>
  export default {

    name: 'FontSizeSwitcher',

    props: {
      size: {
        type: String,
        required: true,
        default: 's'
      }
    },

    methods: {
      change (size) {
        this.$emit('size', size)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn {
    background-color: transparent;
    border-width: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;

    &:focus {
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// FontSizeSwitcher.vue?a2837c74